import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% rabat fra {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Spar {{percentageAmount}}% på udvalgte varer',
  [OfferKindEnum.AmountOffByProducts]: 'Spar {{amount}} på udvalgte varer',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Spar {{amount}} fra {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 til prisen for 1 – kun i dag',
  [OfferKindEnum.BogoHalfPrice]: 'Køb en, få en til halv pris',
  [OfferKindEnum.FreeItemByProducts]: 'I dag: Sikr dig din gratis vare!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'I dag: Sikr dig en gratis vare med en ordreværdi!',
};

export default OfferLabel;
